import axios from "axios";
import { useState } from "react";
import React, { Component }  from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import './App.css';


const API_KEY = process.env.REACT_APP_API_URL

function Signup() {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");


const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`${API_KEY}/api/auth/register`, {
        name,
        email,
        password
    })
    .then(result => {
        navigate('/login');
    })
    .catch(err => {
        console.log(err);
    });
};


    return (
        <div className="d-flex justify-content-center align-items-center bg-secondary vh-100">
            <div className=" p-3 rounded w-25">
                <h2>Sign up</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="name">
                            <strong>Name</strong>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Name"
                            autoComplete="off"
                            name="name"
                            className="form-control rounded-0"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email">
                            <strong>Email</strong>
                        </label>
                        <input
                            type="email"
                            placeholder="Enter Email"
                            autoComplete="off"
                            name="email"
                            className="form-control rounded-0"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password">
                            <strong>Password</strong>
                        </label>
                        <input
                            type="password"
                            placeholder="Enter Password"
                            autoComplete="off"
                            name="password"
                            className="form-control rounded-0"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button type="submit" className="btn btn-purple text-white w-100">
                        Register
                    </button>
                </form>
                <p className="mt-2">Already Have an account</p>
               
            </div>
        </div>
    );
}

export default Signup;
